import LockIcon from "@uui/Lock03";

import { Button, ButtonProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import IconBackground from "@rui/IconBackground";
import Stack from "@rui/Stack";

export const Overlay = styled(Stack)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "#0000008D",
  [theme.breakpoints.up("md")]: {
    top: "-12px",
    "@media (min-height: 780px)": {
      top: 0,
    },
  },
}));

type VideoOptionProps = ButtonProps & { primary: boolean };

export const VideoOptionButton = styled(
  ({ primary: _, ...props }: VideoOptionProps) => (
    <Button variant="contained" {...props} />
  )
)(({ primary, theme, onClick }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  minWidth: "216px",
  boxShadow: "none",
  padding: "12px",
  ...(!primary && {
    backgroundColor: theme.palette.transparent.white[20],
  }),
  ...(!onClick && {
    "&:hover": {
      backgroundColor: theme.palette.transparent.white[20],
      cursor: "default",
      boxShadow: "none",
    },
  }),
  "&.Mui-disabled": {
    backgroundColor: theme.palette.transparent.white[20],
    color: "#FFF",
  },
}));

export const Locked = () => (
  <IconBackground height={20} sx={{ bgcolor: "#4C47CC0F", mr: 0.5 }}>
    <LockIcon sx={{ color: "#FFF", fontSize: "inherit" }} />
  </IconBackground>
);
